import React from 'react';
import { Translate } from 'react-localize-redux';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import { TextField, SwitchField, Button } from '../../components/widgets';
import css from './EditOrg.css';

const EditOrg = props => {
    const { fields, edit, editChange, editConfirm } = props;
    const allowMultipleAudiences = edit.allow_multiple_audiences;
    const maxMultipleAudiences = edit.multiple_audiences_max_amount || 5;
    const visibleFields = fields.filter(field => field.ui_type !== 'hidden');

    const normalizeEntries = rawValue => {
        if (Array.isArray(rawValue)) {
            return rawValue.map(item => {
                if (item && typeof item === 'object') {
                    return { value: item.value || '', uan_id: item.uan_id || null };
                }
                return { value: item || '', uan_id: null };
            });
        }
        if (rawValue && typeof rawValue === 'object') {
            return [{ value: rawValue.value || '', uan_id: rawValue.uan_id || null }];
        }
        if (rawValue) {
            return [{ value: rawValue, uan_id: null }];
        }
        return [{ value: '', uan_id: null }];
    };

    const getFieldEntries = field => normalizeEntries(edit.distribution.config[field.name]);

    const getRowCount = () => {
        if (!allowMultipleAudiences) {
            return 1;
        }
        const lengths = visibleFields.map(field => getFieldEntries(field).length);
        const maxLength = Math.max.apply(Math, lengths.concat([1]));
        return maxLength;
    };

    const updateFieldValueAtIndex = (field, index, value) => {
        const currentEntries = getFieldEntries(field).slice();
        while (currentEntries.length < getRowCount()) {
            currentEntries.push({ value: '', uan_id: null });
        }
        currentEntries[index] = { value, uan_id: currentEntries[index].uan_id };
        editChange(field.name, currentEntries, true);
    };

    const addRow = () => {
        const rowCount = getRowCount();
        if (rowCount >= maxMultipleAudiences) {
            return;
        }
        visibleFields.forEach(field => {
            const currentEntries = getFieldEntries(field);
            editChange(field.name, currentEntries.concat([{ value: '', uan_id: null }]), true);
        });
    };

    const removeRow = index => {
        visibleFields.forEach(field => {
            const currentEntries = getFieldEntries(field);
            const nextEntries = currentEntries.filter((_, idx) => idx !== index);
            editChange(field.name, nextEntries.length ? nextEntries : [{ value: '', uan_id: null }], true);
        });
    };
    return (
        <Card className={css.container}>
            <CardContent className={css.cardContent}>
                <div style={{ textAlign: 'right' }}>
                    <SwitchField
                        label="Active"
                        checked={edit.distribution.active}
                        onChange={checked => {
                            editChange('active', checked);
                        }}
                    />
                </div>
                {allowMultipleAudiences ? (
                    <div className={css.multipleAudienceContainer}>
                        {Array.from({ length: getRowCount() }).map((_, rowIndex) => (
                            <div key={`audience-row-${rowIndex}`} className={css.multipleAudienceRow}>
                                <div className={css.multipleAudienceFields}>
                                    {visibleFields.map(field => (
                                        <TextField
                                            key={`${field.name}-${rowIndex}`}
                                            label={rowIndex === 0 ? field.display : ''}
                                            value={(getFieldEntries(field)[rowIndex] || {}).value || ''}
                                            password={field.ui_type === 'password'}
                                            onChange={value => updateFieldValueAtIndex(field, rowIndex, value)}
                                            autoCompleteOff
                                        />
                                    ))}
                                </div>
                                <div className={css.multipleAudienceActions}>
                                    <Button
                                        type="secondary"
                                        onClick={() => removeRow(rowIndex)}
                                        disabled={getRowCount() === 1}
                                    >
                                        <Translate id="STATIC.PAGES.AUDIENCES.REMOVE_API_KEY" />
                                    </Button>
                                </div>
                            </div>
                        ))}
                        <div className={css.addMultipleAudienceRow}>
                            <Button
                                type="secondary"
                                onClick={addRow}
                                disabled={getRowCount() >= maxMultipleAudiences}
                            >
                                <Translate id="STATIC.PAGES.AUDIENCES.ADD_API_KEY" />
                            </Button>
                        </div>
                    </div>
                ) : (
                    visibleFields.map(field => (
                        <TextField
                            key={field.name}
                            label={field.display}
                            value={edit.distribution.config[field.name]}
                            password={field.ui_type === 'password'}
                            onChange={value => {
                                editChange(field.name, value, true);
                            }}
                            autoCompleteOff
                        />
                    ))
                )}
            </CardContent>
            <CardActions className={css.cardActions}>
                <Button onClick={editConfirm}>
                    <Translate id="STATIC.BUTTONS.SAVE" />
                </Button>
            </CardActions>
        </Card>
    );
};

export default EditOrg;
